import logError from "utils/logError";

import initializeGoogleMaps from "./initializeGoogleMaps";

export default async () => {
  const isFunctionInitialized = () =>
    typeof google !== "undefined" && google?.maps?.geometry?.spherical;
  try {
    if (!isFunctionInitialized()) {
      await initializeGoogleMaps();
    }

    if (isFunctionInitialized()) {
      return google.maps.geometry.spherical;
    }
  } catch {
    logError("Could not intitialize google maps geometry spherical");
  }
};
